import Layout from "@/layout/index.vue";
const employeeManager = {
    path: '/',
    component: Layout,
    redirect: 'noRedirect',
    name: 'employeeManager',
    meta: {
        title: '',
        icon: 'DocumentCopy'
    },
    children: [
        {
            path: 'employee',
            component: () => import('@/views/employee/index.vue'),
            name: 'employee',
            meta: { title: '账号管理', noCache: true,icon: 'DocumentCopy'  }
        },
    ]

}

export default employeeManager
